import { RouteObject } from 'react-router-dom'
import { ItemDetailsPage } from './item-search'

export const ItemSearchRoute: RouteObject = {
    path: '/item-search',
    element: <ItemDetailsPage />,
}
